export default __webpack_public_path__ + "static/media/subject_underline_shine_effect.ca89f32f.png";